// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"selectBoundsMap_wrapper__1b-jU","map-wrapper":"selectBoundsMap_map-wrapper__lIU6i","leaflet-container":"selectBoundsMap_leaflet-container__3VBa4"};